import { render, staticRenderFns } from "./FootMark.vue?vue&type=template&id=3d5cf8c6&scoped=true"
import script from "./FootMark.vue?vue&type=script&lang=js"
export * from "./FootMark.vue?vue&type=script&lang=js"
import style0 from "./FootMark.vue?vue&type=style&index=0&id=3d5cf8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5cf8c6",
  null
  
)

export default component.exports